import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, Download, Edit, Trash2 } from "lucide-react";

export function ExportTemplates() {
  const templates = [
    { id: '1', name: 'Yardi GL Journal Entry', format: 'CSV', fields: 12, used: 234 },
    { id: '2', name: 'QuickBooks IIF Import', format: 'IIF', fields: 15, used: 89 },
    { id: '3', name: 'Xero Invoice CSV', format: 'CSV', fields: 10, used: 156 },
    { id: '4', name: 'Bank ACH Batch File', format: 'NACHA', fields: 8, used: 45 },
  ];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Export Templates</CardTitle>
              <CardDescription>
                Configure export formats for payment file generation
              </CardDescription>
            </div>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              New Template
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {templates.map((template) => (
              <Card key={template.id}>
                <CardContent className="flex items-center justify-between p-4">
                  <div>
                    <h4 className="font-semibold">{template.name}</h4>
                    <div className="flex items-center gap-4 text-sm text-muted-foreground mt-1">
                      <span>Format: {template.format}</span>
                      <span>Mapping: {template.fields} fields</span>
                      <span>Used: {template.used} times</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Button size="sm" variant="outline">
                      <Download className="h-4 w-4 mr-2" />
                      Sample
                    </Button>
                    <Button size="sm" variant="outline">
                      <Edit className="h-4 w-4" />
                    </Button>
                    <Button size="sm" variant="outline">
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
